import './Editor.css'
import { cn } from 'components/UI/cn'
import {
  CommonEditorProps,
  EditorProps,
  useEditorCore,
  EditorToolbar,
} from './EditorCore'

export type { CommonEditorProps } from './EditorCore'

export function Editor(props: EditorProps & CommonEditorProps) {
  const {
    label,
    optional,
    className,
    borderless,
    additionalToolbarButtons,
    toolbarSuffix,
    toolbarClassName,
    plainText,
  } = props
  // Plain-text mode hides the toolbar — there are no formats to apply.
  const disableToolbar = plainText || props.disableToolbar

  const { uniqueId } = useEditorCore(props)

  return (
    <div className="mt-2">
      {label && (
        <label className="text-base font-medium text-gray-800 select-none mb-1">
          {label}
          {optional && (
            <span className={'text-sm italic font-normal'}> - optional</span>
          )}{' '}
        </label>
      )}
      <div className={borderless ? 'borderless-editor' : ''}>
        <div className={className} id={`editor-${uniqueId}`}></div>
        <div
          className={cn(
            toolbarSuffix && [
              'flex items-center gap-2 px-2 py-1',
              'border border-t-0 border-line rounded-b-md',
              '[&_.ql-toolbar]:!border-0 [&_.ql-toolbar]:!rounded-none [&_.ql-toolbar]:!p-0 [&_.ql-toolbar]:!m-0',
              '[&_.ql-toolbar]:!flex [&_.ql-toolbar]:!items-center [&_.ql-toolbar]:!flex-nowrap',
            ],
            toolbarClassName
          )}
          style={{ display: disableToolbar ? 'none' : undefined }}
        >
          <EditorToolbar
            uniqueId={uniqueId}
            disableToolbar={disableToolbar}
            additionalToolbarButtons={additionalToolbarButtons}
          />
          {toolbarSuffix && (
            <div className="ml-auto flex items-center gap-2">
              {toolbarSuffix}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
